import { DynamicHeight, IconArrow } from '@anm/components/Collapse';
import { flexCenter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

type ModalButtonProps = {
  isDisabled: boolean;
  isRightAligned: boolean;
};

export const Wrapper = styled.div`
  position: relative;
  margin-bottom: 22px;

  ${DynamicHeight} {
    overflow: hidden;
  }
`;

export const SectionListWrapper = styled.div`
  ${IconArrow} {
    width: 15px;
    margin-right: 9px;
    margin-bottom: 16px;
  }
  img {
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid rgba(1, 83, 130, 0.2);
  }
`;
const modalButtonDisabledStyled = css`
  color: #919eaa;
  pointer-events: none;
`;

export const ModalButton = styled.p<ModalButtonProps>`
  top: 3px;
  margin: 0;
  color: var(--blue_100);
  cursor: pointer;
  font-size: 14px;
  line-height: 17px;
  position: absolute;
  right: ${({ isRightAligned }) => (isRightAligned ? '0' : '31px')};
  ${({ isDisabled }) => isDisabled && modalButtonDisabledStyled};
`;

export const LoaderContainer = styled.div`
  ${flexCenter};
  width: 100%;
  height: 100%;
  padding: 14px 14px 0 0;
`;

export const ItemWrapper = styled.div`
  border: 1px solid rgba(1, 83, 130, 0.2);
  box-sizing: border-box;
  border-radius: 5px;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: bold;
  font-size: 12px;
  color: #919eaa;

  label {
    display: block;
    position: relative;
    width: 100%;
    min-height: 100%;
    cursor: pointer;

    &:before,
    &:after {
      display: block;
      position: absolute;
      background: #919eaa;
      content: '';
      width: 32px;
      height: 2px;
      left: 50%;
      transform: rotate(0deg) translateX(-50%);
    }

    &:after {
      transform: rotate(90deg) translateX(-50%) translateY(50%);
      transform-origin: 0 100%;
      top: calc(50% - 2px);
    }
    &:before {
      top: calc(50% - 1px);
    }
  }

  input {
    display: none;
  }
`;
